import axios from "axios";

const apiClient = axios.create({
  baseURL: "https://lmsapi.edumitram.com:443",
  headers: {
    "Content-Type": "application/json",
  },
});

//  Attach token automatically
apiClient.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export default apiClient;